<template>
  <div class="wrapper col-6">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-edit"></i> Convert NSL to KML
        </div>
        <br>
        <div class="form-group">

               <b-row>
                <b-col sm="8"> 
                    <b-alert :show="showUploadAlert"
                             dismissible
                             variant="warning">
                        <strong>Conversion completed!</strong> You successfully convert to KML file.
                    </b-alert>
                    <b-alert :show="showUploadError"
                           dismissible
                           variant="danger">
                        <strong>Upload Error!</strong> File size must not exceed 1MB in size.
                    </b-alert>
                    <b-form-group>
                       <file-upload
                            ref='fileUpload'
                            v-bind:have-desc="false"
                            title="Please upload a NSL file to convert KML file."
                            accept=".xlsx, .xls"
                            @event-handler="fileUploadEventHandler($event)">            
                          </file-upload> 
                    </b-form-group>
                </b-col>
              </b-row>
        </div>
        
        <!-- FOOTER -->  
        <div slot="footer" class="float-right">
            <!-- <b-button variant="primary" @click="submitEventHandler" :disabled="!modified"><i class="fa fa-save"></i> Save</b-button>&nbsp; -->
            <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> Close</b-button>
        </div>
        <!--// FOOTER -->  

      </b-card>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import NotificationService from '@/api/NotificationService'
import CommonService from '@/api/CommonService'
import UploadService from '@/api/UploadService'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'

export default {
  components: { 
    FileUpload
  },  
  data () {
    return {
      tabIndex: 0,
      attachment: [],
      inputs: [
        { one: '', two: '' }
      ],
      showUploadAlert: false,
      showUploadError: false,
      isUploadReady: false,      
      local: constants.DATE_LOCALE_EN
    }
  },
  computed: {
  ...mapGetters({
      notificationId: types.GET_NOTIFICATION_ID,
      modified: types.GET_MODIFIED,
      attachments: types.GET_ATTACHMENTS
    })
  },
  methods: {

    closeEventHandler() {
        this.$store.commit(types.MUTATE_RESET_STATE)
        this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        if (this.$store.state.permission === constants.ADMIN) {
            this.$router.replace('/dashboard')
        }    
        else {
            this.$router.replace('/user-dashboard')
        }      
    },

    async fileUploadEventHandler(event) {
      const notificationId = this.$store.state.notificationId
      const requestTypeId = this.$store.state.requestTypeId
      const category = "NSL_DOCUMENT"
      const $this = this
      this.showUploadError = false
      
      let file = event.file
      if (!file) return

      // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      await UploadService.nsl2kml(formData, {responseType: 'arraybuffer'}).then( (resp) => {
          if (resp.length > 0) {
      
              CommonService.downloadKML(resp[0].file).then( (resp) => {
          
              })

              this.$store.commit(types.MUTATE_MODIFIED, true)
              this.isUploadReady = true 

              setTimeout(function () {
                  this.showUploadAlert = false
                  this.$refs.fileUpload.reset()
              }.bind(this), 3000)
          }  
          else {
             toast.error( "Error encountered while processing the file.", "Error")
          }        
      })
    }    
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/NSL2KML.vue